import React, {useState, useContext, useEffect} from 'react';
import { IonLabel, IonInput, IonCol, IonRow, IonDatetime, IonText, IonModal, IonGrid, IonHeader, IonButton, IonLoading } from '@ionic/react';


import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';
import '../../css/layout.css';

export function DateRange(props) {
    
    let authMerchant_objects = useContext(Auth_Zasava_Context);

    let [startDate, setStartDate] = useState(props.data.startDate.toISOString().substr(0, 10));
    let [endDate, setEndDate] = useState(props.data.endDate.toISOString().substr(0, 10));

    function handleDates1(event)
    {

        const newStartDate = event;


        if (newStartDate.toString() != startDate.toString()) {

            setStartDate(event);
            //props.setStartDate(event);
            props.setDate([event, endDate]);
        }
    }

    function handleDates2(event)
    {

        const newEndDate = event;

        if (newEndDate.toString() != endDate.toString()) {

            setEndDate(event);
            //props.setEndDate(event);
            props.setDate([props.data.startDate.toISOString().substr(0, 10), event]);
        }

    }


    useEffect(() => {

        const newStartDate = props.data.startDate.toISOString().substr(0, 10);
        const newEndDate = props.data.endDate.toISOString().substr(0, 10);
    
        if (newStartDate.toString() !== startDate.toString()) {
        setStartDate(newStartDate);
        }

        if (newEndDate.toString() !== endDate.toString()) {
        setEndDate(newEndDate);
        }

      }, [props.data.startDate, props.data.endDate]);


    return (
            <React.Fragment>
                        <IonRow >
                            <IonCol className='dateRange' size='6'>
                                <IonInput type='date' value={startDate} onIonChange={(e)=> handleDates1([new Date(e.target.value).toISOString().substr(0, 10)])}> </IonInput>
                            </IonCol>
                            <IonCol className='dateRange' size='6'>
                                <IonInput type='date' value={endDate} onIonChange={(e)=> handleDates2([new Date(e.target.value).toISOString().substr(0, 10)])}> </IonInput>
                            </IonCol>
                        </IonRow>



            </React.Fragment>
    )

}